import { create } from 'zustand';

interface NotificationsState {
  unreadCount: number;
  setUnreadCount: (n: number) => void;
  incrementUnread: (by?: number) => void;
  decrementUnread: (by?: number) => void;
  clear: () => void;
}

export const useNotificationsStore = create<NotificationsState>((set) => ({
  unreadCount: 0,
  setUnreadCount: (n) => set({ unreadCount: Math.max(0, n) }),
  incrementUnread: (by = 1) => set((s) => ({ unreadCount: Math.max(0, s.unreadCount + by) })),
  decrementUnread: (by = 1) => set((s) => ({ unreadCount: Math.max(0, s.unreadCount - by) })),
  clear: () => set({ unreadCount: 0 }),
}));
